import React from 'react';
import { Link, NavLink } from 'react-router-dom';

function NavBar() {
  // Función para cerrar el menú colapsable en mobile
  const handleNavLinkClick = () => {
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse && window.innerWidth < 992) {
      // Bootstrap 5 usa la clase 'show' para mostrar el collapse
      if (navbarCollapse.classList.contains('show')) {
        const bsCollapse = window.bootstrap && window.bootstrap.Collapse
          ? window.bootstrap.Collapse.getOrCreateInstance(navbarCollapse)
          : null;
        if (bsCollapse) {
          bsCollapse.hide();
        } else {
          navbarCollapse.classList.remove('show');
        }
      }
    }
  };

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary custom-navbar-padding">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" style={{ maxWidth: '160px', width: '90%', height: 'auto' }} />
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto custom-navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link custom-navbar-link" to="/" onClick={handleNavLinkClick}>INICIO</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link custom-navbar-link" to="/nosotros" onClick={handleNavLinkClick}>NOSOTROS</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link custom-navbar-link" to="/servicio" onClick={handleNavLinkClick}>SERVICIOS</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link custom-navbar-link" to="/sucursales" onClick={handleNavLinkClick}>SUCURSALES</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link custom-navbar-link" to="/galeria" onClick={handleNavLinkClick}>GALERÍA</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link custom-navbar-link" to="/contacto" onClick={handleNavLinkClick}>CONTACTO</NavLink>
            </li>
            <li className="nav-item d-block d-lg-none">
                <div className="container-fluid custom-navbar-icons-container p-0">
                <div className="row justify-content-center align-items-center g-2">
                  <div className="col d-flex justify-content-center">
                    <a href="https://www.facebook.com/opticasparisver?locale=es_LA" target="_blank" rel="noopener noreferrer">
                      <img src={process.env.PUBLIC_URL + '/facebook.png'} alt="Facebook" className="custom-navbar-icon" />
                    </a>
                  </div>
                  <div className="col d-flex justify-content-center">
                    <a href="https://www.instagram.com/opticasparisver/" target="_blank" rel="noopener noreferrer">
                      <img src={process.env.PUBLIC_URL + '/instagram.png'} alt="Instagram" className="custom-navbar-icon" />
                    </a>
                  </div>
                  <div className="col d-flex justify-content-center">
                    <a href="https://www.youtube.com/@OPV%C3%93pticaParis" target="_blank" rel="noopener noreferrer">
                      <img src={process.env.PUBLIC_URL + '/youtube.png'} alt="YouTube" className="custom-navbar-icon" />
                    </a>
                  </div>
                  <div className="col d-flex justify-content-center">
                    <a href="https://www.tiktok.com/@opticasparisver?_t=ZN-8z2HG1gzDuw&_r=1" target="_blank" rel="noopener noreferrer">
                      <img src={process.env.PUBLIC_URL + '/TikTok.png'} alt="Tiktok" className="custom-navbar-icon" />
                    </a>
                  </div>
                  <div className="col d-flex justify-content-center">
                    <a href="https://listado.mercadolibre.com.mx/_CustId_1228846715?item_id=MLM1679229684&category_id=MLM189030&seller_id=1228846715&client=recoview-selleritems&recos_listing=true#origin=vip&component=sellerData&typeSeller=classic" target="_blank" rel="noopener noreferrer">
                      <img src={process.env.PUBLIC_URL + '/mercadolibre.png'} alt="MercadoLibre" className="custom-navbar-icon" />
                    </a>
                  </div>
                  
                </div>
              </div>
            </li>
          </ul>
          <div className="container custom-navbar-icons-container d-none d-lg-block">
            <div className="row justify-content-center align-items-center g-2">
              <div className="col d-flex justify-content-center">
                <a href="https://www.facebook.com/opticasparisver?locale=es_LA" target="_blank" rel="noopener noreferrer">
                  <img src={process.env.PUBLIC_URL + '/facebook.png'} alt="Facebook" className="custom-navbar-icon" />
                </a>
              </div>
              <div className="col d-flex justify-content-center">
                <a href="https://www.instagram.com/opticasparisver/" target="_blank" rel="noopener noreferrer">
                  <img src={process.env.PUBLIC_URL + '/instagram.png'} alt="Instagram" className="custom-navbar-icon" />
                </a>
              </div>
              <div className="col d-flex justify-content-center">
                <a href="https://www.youtube.com/@OPV%C3%93pticaParis" target="_blank" rel="noopener noreferrer">
                  <img src={process.env.PUBLIC_URL + '/youtube.png'} alt="YouTube" className="custom-navbar-icon" />
                </a>
              </div>
              <div className="col d-flex justify-content-center">
                <a href="https://www.tiktok.com/@opticasparisver?_t=ZN-8z2HG1gzDuw&_r=1" target="_blank" rel="noopener noreferrer">
                  <img src={process.env.PUBLIC_URL + '/TikTok.png'} alt="Tiktok" className="custom-navbar-icon" />
                </a>
              </div>
              <div className="col d-flex justify-content-center">
                <a href="https://listado.mercadolibre.com.mx/_CustId_1228846715?item_id=MLM1679229684&category_id=MLM189030&seller_id=1228846715&client=recoview-selleritems&recos_listing=true#origin=vip&component=sellerData&typeSeller=classic" target="_blank" rel="noopener noreferrer">
                  <img src={process.env.PUBLIC_URL + '/mercadolibre.png'} alt="MercadoLibre" className="custom-navbar-icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar; 